"use strict";

function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
Object.defineProperty(exports, "__esModule", {
  value: true
});
var ed5 = require("xmlchars/xml/1.0/ed5");
var ed2 = require("xmlchars/xml/1.1/ed2");
var NSed3 = require("xmlchars/xmlns/1.0/ed3");
var isS = ed5.isS;
var isChar10 = ed5.isChar;
var isNameStartChar = ed5.isNameStartChar;
var isNameChar = ed5.isNameChar;
var S_LIST = ed5.S_LIST;
var NAME_RE = ed5.NAME_RE;
var isChar11 = ed2.isChar;
var isNCNameStartChar = NSed3.isNCNameStartChar;
var isNCNameChar = NSed3.isNCNameChar;
var NC_NAME_RE = NSed3.NC_NAME_RE;
var XML_NAMESPACE = "http://www.w3.org/XML/1998/namespace";
var XMLNS_NAMESPACE = "http://www.w3.org/2000/xmlns/";
var rootNS = {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  __proto__: null,
  xml: XML_NAMESPACE,
  xmlns: XMLNS_NAMESPACE
};
var XML_ENTITIES = {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  __proto__: null,
  amp: "&",
  gt: ">",
  lt: "<",
  quot: "\"",
  apos: "'"
};
// EOC: end-of-chunk
var EOC = -1;
var NL_LIKE = -2;
var S_BEGIN = 0; // Initial state.
var S_BEGIN_WHITESPACE = 1; // leading whitespace
var S_DOCTYPE = 2; // <!DOCTYPE
var S_DOCTYPE_QUOTE = 3; // <!DOCTYPE "//blah
var S_DTD = 4; // <!DOCTYPE "//blah" [ ...
var S_DTD_QUOTED = 5; // <!DOCTYPE "//blah" [ "foo
var S_DTD_OPEN_WAKA = 6;
var S_DTD_OPEN_WAKA_BANG = 7;
var S_DTD_COMMENT = 8; // <!--
var S_DTD_COMMENT_ENDING = 9; // <!-- blah -
var S_DTD_COMMENT_ENDED = 10; // <!-- blah --
var S_DTD_PI = 11; // <?
var S_DTD_PI_ENDING = 12; // <?hi "there" ?
var S_TEXT = 13; // general stuff
var S_ENTITY = 14; // &amp and such
var S_OPEN_WAKA = 15; // <
var S_OPEN_WAKA_BANG = 16; // <!...
var S_COMMENT = 17; // <!--
var S_COMMENT_ENDING = 18; // <!-- blah -
var S_COMMENT_ENDED = 19; // <!-- blah --
var S_CDATA = 20; // <![CDATA[ something
var S_CDATA_ENDING = 21; // ]
var S_CDATA_ENDING_2 = 22; // ]]
var S_PI_FIRST_CHAR = 23; // <?hi, first char
var S_PI_REST = 24; // <?hi, rest of the name
var S_PI_BODY = 25; // <?hi there
var S_PI_ENDING = 26; // <?hi "there" ?
var S_XML_DECL_NAME_START = 27; // <?xml
var S_XML_DECL_NAME = 28; // <?xml foo
var S_XML_DECL_EQ = 29; // <?xml foo=
var S_XML_DECL_VALUE_START = 30; // <?xml foo=
var S_XML_DECL_VALUE = 31; // <?xml foo="bar"
var S_XML_DECL_SEPARATOR = 32; // <?xml foo="bar"
var S_XML_DECL_ENDING = 33; // <?xml ... ?
var S_OPEN_TAG = 34; // <strong
var S_OPEN_TAG_SLASH = 35; // <strong /
var S_ATTRIB = 36; // <a
var S_ATTRIB_NAME = 37; // <a foo
var S_ATTRIB_NAME_SAW_WHITE = 38; // <a foo _
var S_ATTRIB_VALUE = 39; // <a foo=
var S_ATTRIB_VALUE_QUOTED = 40; // <a foo="bar
var S_ATTRIB_VALUE_CLOSED = 41; // <a foo="bar"
var S_ATTRIB_VALUE_UNQUOTED = 42; // <a foo=bar
var S_CLOSE_TAG = 43; // </a
var S_CLOSE_TAG_SAW_WHITE = 44; // </a   >
var TAB = 9;
var NL = 0xA;
var CR = 0xD;
var SPACE = 0x20;
var BANG = 0x21;
var DQUOTE = 0x22;
var AMP = 0x26;
var SQUOTE = 0x27;
var MINUS = 0x2D;
var FORWARD_SLASH = 0x2F;
var SEMICOLON = 0x3B;
var LESS = 0x3C;
var EQUAL = 0x3D;
var GREATER = 0x3E;
var QUESTION = 0x3F;
var OPEN_BRACKET = 0x5B;
var CLOSE_BRACKET = 0x5D;
var NEL = 0x85;
var LS = 0x2028; // Line Separator
var isQuote = function isQuote(c) {
  return c === DQUOTE || c === SQUOTE;
};
var QUOTES = [DQUOTE, SQUOTE];
var DOCTYPE_TERMINATOR = [].concat(QUOTES, [OPEN_BRACKET, GREATER]);
var DTD_TERMINATOR = [].concat(QUOTES, [LESS, CLOSE_BRACKET]);
var XML_DECL_NAME_TERMINATOR = [EQUAL, QUESTION].concat(_toConsumableArray(S_LIST));
var ATTRIB_VALUE_UNQUOTED_TERMINATOR = [].concat(_toConsumableArray(S_LIST), [GREATER, AMP, LESS]);
function nsPairCheck(parser, prefix, uri) {
  switch (prefix) {
    case "xml":
      if (uri !== XML_NAMESPACE) {
        parser.fail("xml prefix must be bound to ".concat(XML_NAMESPACE, "."));
      }
      break;
    case "xmlns":
      if (uri !== XMLNS_NAMESPACE) {
        parser.fail("xmlns prefix must be bound to ".concat(XMLNS_NAMESPACE, "."));
      }
      break;
    default:
  }
  switch (uri) {
    case XMLNS_NAMESPACE:
      parser.fail(prefix === "" ? "the default namespace may not be set to ".concat(uri, ".") : "may not assign a prefix (even \"xmlns\") to the URI ".concat(XMLNS_NAMESPACE, "."));
      break;
    case XML_NAMESPACE:
      switch (prefix) {
        case "xml":
          // Assinging the XML namespace to "xml" is fine.
          break;
        case "":
          parser.fail("the default namespace may not be set to ".concat(uri, "."));
          break;
        default:
          parser.fail("may not assign the xml namespace to another prefix.");
      }
      break;
    default:
  }
}
function nsMappingCheck(parser, mapping) {
  for (var _i = 0, _Object$keys = Object.keys(mapping); _i < _Object$keys.length; _i++) {
    var local = _Object$keys[_i];
    nsPairCheck(parser, local, mapping[local]);
  }
}
var isNCName = function isNCName(name) {
  return NC_NAME_RE.test(name);
};
var isName = function isName(name) {
  return NAME_RE.test(name);
};
var FORBIDDEN_START = 0;
var FORBIDDEN_BRACKET = 1;
var FORBIDDEN_BRACKET_BRACKET = 2;
/**
 * The list of supported events.
 */
exports.EVENTS = ["xmldecl", "text", "processinginstruction", "doctype", "comment", "opentagstart", "attribute", "opentag", "closetag", "cdata", "error", "end", "ready"];
var EVENT_NAME_TO_HANDLER_NAME = {
  xmldecl: "xmldeclHandler",
  text: "textHandler",
  processinginstruction: "piHandler",
  doctype: "doctypeHandler",
  comment: "commentHandler",
  opentagstart: "openTagStartHandler",
  attribute: "attributeHandler",
  opentag: "openTagHandler",
  closetag: "closeTagHandler",
  cdata: "cdataHandler",
  error: "errorHandler",
  end: "endHandler",
  ready: "readyHandler"
};
var SaxesParser = /*#__PURE__*/function () {
  /**
   * @param opt The parser options.
   */
  function SaxesParser(opt) {
    _classCallCheck(this, SaxesParser);
    this.opt = opt !== null && opt !== void 0 ? opt : {};
    this.fragmentOpt = !!this.opt.fragment;
    var xmlnsOpt = this.xmlnsOpt = !!this.opt.xmlns;
    this.trackPosition = this.opt.position !== false;
    this.fileName = this.opt.fileName;
    if (xmlnsOpt) {
      // This is the function we use to perform name checks on PIs and entities.
      // When namespaces are used, colons are not allowed in PI target names or
      // entity names. So the check depends on whether namespaces are used. See:
      //
      // https://www.w3.org/XML/xml-names-19990114-errata.html
      // NE08
      //
      this.nameStartCheck = isNCNameStartChar;
      this.nameCheck = isNCNameChar;
      this.isName = isNCName;
      // eslint-disable-next-line @typescript-eslint/unbound-method
      this.processAttribs = this.processAttribsNS;
      // eslint-disable-next-line @typescript-eslint/unbound-method
      this.pushAttrib = this.pushAttribNS;
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      this.ns = Object.assign({
        __proto__: null
      }, rootNS);
      var additional = this.opt.additionalNamespaces;
      if (additional != null) {
        nsMappingCheck(this, additional);
        Object.assign(this.ns, additional);
      }
    } else {
      this.nameStartCheck = isNameStartChar;
      this.nameCheck = isNameChar;
      this.isName = isName;
      // eslint-disable-next-line @typescript-eslint/unbound-method
      this.processAttribs = this.processAttribsPlain;
      // eslint-disable-next-line @typescript-eslint/unbound-method
      this.pushAttrib = this.pushAttribPlain;
    }
    //
    // The order of the members in this table needs to correspond to the state
    // numbers given to the states that correspond to the methods being recorded
    // here.
    //
    this.stateTable = [/* eslint-disable @typescript-eslint/unbound-method */
    this.sBegin, this.sBeginWhitespace, this.sDoctype, this.sDoctypeQuote, this.sDTD, this.sDTDQuoted, this.sDTDOpenWaka, this.sDTDOpenWakaBang, this.sDTDComment, this.sDTDCommentEnding, this.sDTDCommentEnded, this.sDTDPI, this.sDTDPIEnding, this.sText, this.sEntity, this.sOpenWaka, this.sOpenWakaBang, this.sComment, this.sCommentEnding, this.sCommentEnded, this.sCData, this.sCDataEnding, this.sCDataEnding2, this.sPIFirstChar, this.sPIRest, this.sPIBody, this.sPIEnding, this.sXMLDeclNameStart, this.sXMLDeclName, this.sXMLDeclEq, this.sXMLDeclValueStart, this.sXMLDeclValue, this.sXMLDeclSeparator, this.sXMLDeclEnding, this.sOpenTag, this.sOpenTagSlash, this.sAttrib, this.sAttribName, this.sAttribNameSawWhite, this.sAttribValue, this.sAttribValueQuoted, this.sAttribValueClosed, this.sAttribValueUnquoted, this.sCloseTag, this.sCloseTagSawWhite];
    this._init();
  }
  /**
   * Indicates whether or not the parser is closed. If ``true``, wait for
   * the ``ready`` event to write again.
   */
  return _createClass(SaxesParser, [{
    key: "closed",
    get: function get() {
      return this._closed;
    }
  }, {
    key: "_init",
    value: function _init() {
      var _a;
      this.openWakaBang = "";
      this.text = "";
      this.name = "";
      this.piTarget = "";
      this.entity = "";
      this.q = null;
      this.tags = [];
      this.tag = null;
      this.topNS = null;
      this.chunk = "";
      this.chunkPosition = 0;
      this.i = 0;
      this.prevI = 0;
      this.carriedFromPrevious = undefined;
      this.forbiddenState = FORBIDDEN_START;
      this.attribList = [];
      // The logic is organized so as to minimize the need to check
      // this.opt.fragment while parsing.
      var fragmentOpt = this.fragmentOpt;
      this.state = fragmentOpt ? S_TEXT : S_BEGIN;
      // We want these to be all true if we are dealing with a fragment.
      this.reportedTextBeforeRoot = this.reportedTextAfterRoot = this.closedRoot = this.sawRoot = fragmentOpt;
      // An XML declaration is intially possible only when parsing whole
      // documents.
      this.xmlDeclPossible = !fragmentOpt;
      this.xmlDeclExpects = ["version"];
      this.entityReturnState = undefined;
      var defaultXMLVersion = this.opt.defaultXMLVersion;
      if (defaultXMLVersion === undefined) {
        if (this.opt.forceXMLVersion === true) {
          throw new Error("forceXMLVersion set but defaultXMLVersion is not set");
        }
        defaultXMLVersion = "1.0";
      }
      this.setXMLVersion(defaultXMLVersion);
      this.positionAtNewLine = 0;
      this.doctype = false;
      this._closed = false;
      this.xmlDecl = {
        version: undefined,
        encoding: undefined,
        standalone: undefined
      };
      this.line = 1;
      this.column = 0;
      this.ENTITIES = Object.create(XML_ENTITIES);
      // eslint-disable-next-line no-unused-expressions
      (_a = this.readyHandler) === null || _a === void 0 ? void 0 : _a.call(this);
    }
    /**
     * The stream position the parser is currently looking at. This field is
     * zero-based.
     *
     * This field is not based on counting Unicode characters but is to be
     * interpreted as a plain index into a JavaScript string.
     */
  }, {
    key: "position",
    get: function get() {
      return this.chunkPosition + this.i;
    }
    /**
     * The column number of the next character to be read by the parser.  *
     * This field is zero-based. (The first column in a line is 0.)
     *
     * This field reports the index at which the next character would be in the
     * line if the line were represented as a JavaScript string.  Note that this
     * *can* be different to a count based on the number of *Unicode characters*
     * due to how JavaScript handles astral plane characters.
     *
     * See [[column]] for a number that corresponds to a count of Unicode
     * characters.
     */
  }, {
    key: "columnIndex",
    get: function get() {
      return this.position - this.positionAtNewLine;
    }
    /**
     * Set an event listener on an event. The parser supports one handler per
     * event type. If you try to set an event handler over an existing handler,
     * the old handler is silently overwritten.
     *
     * @param name The event to listen to.
     *
     * @param handler The handler to set.
     */
  }, {
    key: "on",
    value: function on(name, handler) {
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      this[EVENT_NAME_TO_HANDLER_NAME[name]] = handler;
    }
    /**
     * Unset an event handler.
     *
     * @parma name The event to stop listening to.
     */
  }, {
    key: "off",
    value: function off(name) {
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      this[EVENT_NAME_TO_HANDLER_NAME[name]] = undefined;
    }
    /**
     * Make an error object. The error object will have a message that contains
     * the ``fileName`` option passed at the creation of the parser. If position
     * tracking was turned on, it will also have line and column number
     * information.
     *
     * @param message The message describing the error to report.
     *
     * @returns An error object with a properly formatted message.
     */
  }, {
    key: "makeError",
    value: function makeError(message) {
      var _a;
      var msg = (_a = this.fileName) !== null && _a !== void 0 ? _a : "";
      if (this.trackPosition) {
        if (msg.length > 0) {
          msg += ":";
        }
        msg += "".concat(this.line, ":").concat(this.column);
      }
      if (msg.length > 0) {
        msg += ": ";
      }
      return new Error(msg + message);
    }
    /**
     * Report a parsing error. This method is made public so that client code may
     * check for issues that are outside the scope of this project and can report
     * errors.
     *
     * @param message The error to report.
     *
     * @returns this
     */
  }, {
    key: "fail",
    value: function fail(message) {
      var err = this.makeError(message);
      var handler = this.errorHandler;
      if (handler === undefined) {
        throw err;
      } else {
        handler(err);
      }
      return this;
    }
    /**
     * Write a XML data to the parser.
     *
     * @param chunk The XML data to write.
     *
     * @returns this
     */
  }, {
    key: "write",
    value: function write(chunk) {
      if (this.closed) {
        return this.fail("cannot write after close; assign an onready handler.");
      }
      var end = false;
      if (chunk === null) {
        // We cannot return immediately because carriedFromPrevious may need
        // processing.
        end = true;
        chunk = "";
      } else if (_typeof(chunk) === "object") {
        chunk = chunk.toString();
      }
      // We checked if performing a pre-decomposition of the string into an array
      // of single complete characters (``Array.from(chunk)``) would be faster
      // than the current repeated calls to ``charCodeAt``. As of August 2018, it
      // isn't. (There may be Node-specific code that would perform faster than
      // ``Array.from`` but don't want to be dependent on Node.)
      if (this.carriedFromPrevious !== undefined) {
        // The previous chunk had char we must carry over.
        chunk = "".concat(this.carriedFromPrevious).concat(chunk);
        this.carriedFromPrevious = undefined;
      }
      var limit = chunk.length;
      var lastCode = chunk.charCodeAt(limit - 1);
      if (!end && (
      // A trailing CR or surrogate must be carried over to the next
      // chunk.
      lastCode === CR || lastCode >= 0xD800 && lastCode <= 0xDBFF)) {
        // The chunk ends with a character that must be carried over. We cannot
        // know how to handle it until we get the next chunk or the end of the
        // stream. So save it for later.
        this.carriedFromPrevious = chunk[limit - 1];
        limit--;
        chunk = chunk.slice(0, limit);
      }
      var stateTable = this.stateTable;
      this.chunk = chunk;
      this.i = 0;
      while (this.i < limit) {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        stateTable[this.state].call(this);
      }
      this.chunkPosition += limit;
      return end ? this.end() : this;
    }
    /**
     * Close the current stream. Perform final well-formedness checks and reset
     * the parser tstate.
     *
     * @returns this
     */
  }, {
    key: "close",
    value: function close() {
      return this.write(null);
    }
    /**
     * Get a single code point out of the current chunk. This updates the current
     * position if we do position tracking.
     *
     * This is the algorithm to use for XML 1.0.
     *
     * @returns The character read.
     */
  }, {
    key: "getCode10",
    value: function getCode10() {
      var chunk = this.chunk,
        i = this.i;
      this.prevI = i;
      // Yes, we do this instead of doing this.i++. Doing it this way, we do not
      // read this.i again, which is a bit faster.
      this.i = i + 1;
      if (i >= chunk.length) {
        return EOC;
      }
      // Using charCodeAt and handling the surrogates ourselves is faster
      // than using codePointAt.
      var code = chunk.charCodeAt(i);
      this.column++;
      if (code < 0xD800) {
        if (code >= SPACE || code === TAB) {
          return code;
        }
        switch (code) {
          case NL:
            this.line++;
            this.column = 0;
            this.positionAtNewLine = this.position;
            return NL;
          case CR:
            // We may get NaN if we read past the end of the chunk, which is fine.
            if (chunk.charCodeAt(i + 1) === NL) {
              // A \r\n sequence is converted to \n so we have to skip over the
              // next character. We already know it has a size of 1 so ++ is fine
              // here.
              this.i = i + 2;
            }
            // Otherwise, a \r is just converted to \n, so we don't have to skip
            // ahead.
            // In either case, \r becomes \n.
            this.line++;
            this.column = 0;
            this.positionAtNewLine = this.position;
            return NL_LIKE;
          default:
            // If we get here, then code < SPACE and it is not NL CR or TAB.
            this.fail("disallowed character.");
            return code;
        }
      }
      if (code > 0xDBFF) {
        // This is a specialized version of isChar10 that takes into account
        // that in this context code > 0xDBFF and code <= 0xFFFF. So it does not
        // test cases that don't need testing.
        if (!(code >= 0xE000 && code <= 0xFFFD)) {
          this.fail("disallowed character.");
        }
        return code;
      }
      var final = 0x10000 + (code - 0xD800) * 0x400 + (chunk.charCodeAt(i + 1) - 0xDC00);
      this.i = i + 2;
      // This is a specialized version of isChar10 that takes into account that in
      // this context necessarily final >= 0x10000.
      if (final > 0x10FFFF) {
        this.fail("disallowed character.");
      }
      return final;
    }
    /**
     * Get a single code point out of the current chunk. This updates the current
     * position if we do position tracking.
     *
     * This is the algorithm to use for XML 1.1.
     *
     * @returns {number} The character read.
     */
  }, {
    key: "getCode11",
    value: function getCode11() {
      var chunk = this.chunk,
        i = this.i;
      this.prevI = i;
      // Yes, we do this instead of doing this.i++. Doing it this way, we do not
      // read this.i again, which is a bit faster.
      this.i = i + 1;
      if (i >= chunk.length) {
        return EOC;
      }
      // Using charCodeAt and handling the surrogates ourselves is faster
      // than using codePointAt.
      var code = chunk.charCodeAt(i);
      this.column++;
      if (code < 0xD800) {
        if (code > 0x1F && code < 0x7F || code > 0x9F && code !== LS || code === TAB) {
          return code;
        }
        switch (code) {
          case NL:
            // 0xA
            this.line++;
            this.column = 0;
            this.positionAtNewLine = this.position;
            return NL;
          case CR:
            {
              // 0xD
              // We may get NaN if we read past the end of the chunk, which is
              // fine.
              var next = chunk.charCodeAt(i + 1);
              if (next === NL || next === NEL) {
                // A CR NL or CR NEL sequence is converted to NL so we have to skip
                // over the next character. We already know it has a size of 1.
                this.i = i + 2;
              }
              // Otherwise, a CR is just converted to NL, no skip.
            }
          /* yes, fall through */
          case NEL: // 0x85
          case LS:
            // Ox2028
            this.line++;
            this.column = 0;
            this.positionAtNewLine = this.position;
            return NL_LIKE;
          default:
            this.fail("disallowed character.");
            return code;
        }
      }
      if (code > 0xDBFF) {
        // This is a specialized version of isCharAndNotRestricted that takes into
        // account that in this context code > 0xDBFF and code <= 0xFFFF. So it
        // does not test cases that don't need testing.
        if (!(code >= 0xE000 && code <= 0xFFFD)) {
          this.fail("disallowed character.");
        }
        return code;
      }
      var final = 0x10000 + (code - 0xD800) * 0x400 + (chunk.charCodeAt(i + 1) - 0xDC00);
      this.i = i + 2;
      // This is a specialized version of isCharAndNotRestricted that takes into
      // account that in this context necessarily final >= 0x10000.
      if (final > 0x10FFFF) {
        this.fail("disallowed character.");
      }
      return final;
    }
    /**
     * Like ``getCode`` but with the return value normalized so that ``NL`` is
     * returned for ``NL_LIKE``.
     */
  }, {
    key: "getCodeNorm",
    value: function getCodeNorm() {
      var c = this.getCode();
      return c === NL_LIKE ? NL : c;
    }
  }, {
    key: "unget",
    value: function unget() {
      this.i = this.prevI;
      this.column--;
    }
    /**
     * Capture characters into a buffer until encountering one of a set of
     * characters.
     *
     * @param chars An array of codepoints. Encountering a character in the array
     * ends the capture. (``chars`` may safely contain ``NL``.)
     *
     * @return The character code that made the capture end, or ``EOC`` if we hit
     * the end of the chunk. The return value cannot be NL_LIKE: NL is returned
     * instead.
     */
  }, {
    key: "captureTo",
    value: function captureTo(chars) {
      var start = this.i;
      var chunk = this.chunk;
      // eslint-disable-next-line no-constant-condition
      while (true) {
        var c = this.getCode();
        var isNLLike = c === NL_LIKE;
        var final = isNLLike ? NL : c;
        if (final === EOC || chars.includes(final)) {
          this.text += chunk.slice(start, this.prevI);
          return final;
        }
        if (isNLLike) {
          this.text += "".concat(chunk.slice(start, this.prevI), "\n");
          start = this.i;
        }
      }
    }
    /**
     * Capture characters into a buffer until encountering a character.
     *
     * @param char The codepoint that ends the capture. **NOTE ``char`` MAY NOT
     * CONTAIN ``NL``.** Passing ``NL`` will result in buggy behavior.
     *
     * @return ``true`` if we ran into the character. Otherwise, we ran into the
     * end of the current chunk.
     */
  }, {
    key: "captureToChar",
    value: function captureToChar(char) {
      var start = this.i;
      var chunk = this.chunk;
      // eslint-disable-next-line no-constant-condition
      while (true) {
        var c = this.getCode();
        switch (c) {
          case NL_LIKE:
            this.text += "".concat(chunk.slice(start, this.prevI), "\n");
            start = this.i;
            c = NL;
            break;
          case EOC:
            this.text += chunk.slice(start);
            return false;
          default:
        }
        if (c === char) {
          this.text += chunk.slice(start, this.prevI);
          return true;
        }
      }
    }
    /**
     * Capture characters that satisfy ``isNameChar`` into the ``name`` field of
     * this parser.
     *
     * @return The character code that made the test fail, or ``EOC`` if we hit
     * the end of the chunk. The return value cannot be NL_LIKE: NL is returned
     * instead.
     */
  }, {
    key: "captureNameChars",
    value: function captureNameChars() {
      var chunk = this.chunk,
        start = this.i;
      // eslint-disable-next-line no-constant-condition
      while (true) {
        var c = this.getCode();
        if (c === EOC) {
          this.name += chunk.slice(start);
          return EOC;
        }
        // NL is not a name char so we don't have to test specifically for it.
        if (!isNameChar(c)) {
          this.name += chunk.slice(start, this.prevI);
          return c === NL_LIKE ? NL : c;
        }
      }
    }
    /**
     * Skip white spaces.
     *
     * @return The character that ended the skip, or ``EOC`` if we hit
     * the end of the chunk. The return value cannot be NL_LIKE: NL is returned
     * instead.
     */
  }, {
    key: "skipSpaces",
    value: function skipSpaces() {
      // eslint-disable-next-line no-constant-condition
      while (true) {
        var c = this.getCodeNorm();
        if (c === EOC || !isS(c)) {
          return c;
        }
      }
    }
  }, {
    key: "setXMLVersion",
    value: function setXMLVersion(version) {
      this.currentXMLVersion = version;
      /*  eslint-disable @typescript-eslint/unbound-method */
      if (version === "1.0") {
        this.isChar = isChar10;
        this.getCode = this.getCode10;
      } else {
        this.isChar = isChar11;
        this.getCode = this.getCode11;
      }
      /* eslint-enable @typescript-eslint/unbound-method */
    }
    // STATE ENGINE METHODS
    // This needs to be a state separate from S_BEGIN_WHITESPACE because we want
    // to be sure never to come back to this state later.
  }, {
    key: "sBegin",
    value: function sBegin() {
      // We are essentially peeking at the first character of the chunk. Since
      // S_BEGIN can be in effect only when we start working on the first chunk,
      // the index at which we must look is necessarily 0. Note also that the
      // following test does not depend on decoding surrogates.
      // If the initial character is 0xFEFF, ignore it.
      if (this.chunk.charCodeAt(0) === 0xFEFF) {
        this.i++;
        this.column++;
      }
      this.state = S_BEGIN_WHITESPACE;
    }
  }, {
    key: "sBeginWhitespace",
    value: function sBeginWhitespace() {
      // We need to know whether we've encountered spaces or not because as soon
      // as we run into a space, an XML declaration is no longer possible. Rather
      // than slow down skipSpaces even in places where we don't care whether it
      // skipped anything or not, we check whether prevI is equal to the value of
      // i from before we skip spaces.
      var iBefore = this.i;
      var c = this.skipSpaces();
      if (this.prevI !== iBefore) {
        this.xmlDeclPossible = false;
      }
      switch (c) {
        case LESS:
          this.state = S_OPEN_WAKA;
          // We could naively call closeText but in this state, it is not normal
          // to have text be filled with any data.
          if (this.text.length !== 0) {
            throw new Error("no-empty text at start");
          }
          break;
        case EOC:
          break;
        default:
          this.unget();
          this.state = S_TEXT;
          this.xmlDeclPossible = false;
      }
    }
  }, {
    key: "sDoctype",
    value: function sDoctype() {
      var _a;
      var c = this.captureTo(DOCTYPE_TERMINATOR);
      switch (c) {
        case GREATER:
          {
            // eslint-disable-next-line no-unused-expressions
            (_a = this.doctypeHandler) === null || _a === void 0 ? void 0 : _a.call(this, this.text);
            this.text = "";
            this.state = S_TEXT;
            this.doctype = true; // just remember that we saw it.
            break;
          }
        case EOC:
          break;
        default:
          this.text += String.fromCodePoint(c);
          if (c === OPEN_BRACKET) {
            this.state = S_DTD;
          } else if (isQuote(c)) {
            this.state = S_DOCTYPE_QUOTE;
            this.q = c;
          }
      }
    }
  }, {
    key: "sDoctypeQuote",
    value: function sDoctypeQuote() {
      var q = this.q;
      if (this.captureToChar(q)) {
        this.text += String.fromCodePoint(q);
        this.q = null;
        this.state = S_DOCTYPE;
      }
    }
  }, {
    key: "sDTD",
    value: function sDTD() {
      var c = this.captureTo(DTD_TERMINATOR);
      if (c === EOC) {
        return;
      }
      this.text += String.fromCodePoint(c);
      if (c === CLOSE_BRACKET) {
        this.state = S_DOCTYPE;
      } else if (c === LESS) {
        this.state = S_DTD_OPEN_WAKA;
      } else if (isQuote(c)) {
        this.state = S_DTD_QUOTED;
        this.q = c;
      }
    }
  }, {
    key: "sDTDQuoted",
    value: function sDTDQuoted() {
      var q = this.q;
      if (this.captureToChar(q)) {
        this.text += String.fromCodePoint(q);
        this.state = S_DTD;
        this.q = null;
      }
    }
  }, {
    key: "sDTDOpenWaka",
    value: function sDTDOpenWaka() {
      var c = this.getCodeNorm();
      this.text += String.fromCodePoint(c);
      switch (c) {
        case BANG:
          this.state = S_DTD_OPEN_WAKA_BANG;
          this.openWakaBang = "";
          break;
        case QUESTION:
          this.state = S_DTD_PI;
          break;
        default:
          this.state = S_DTD;
      }
    }
  }, {
    key: "sDTDOpenWakaBang",
    value: function sDTDOpenWakaBang() {
      var char = String.fromCodePoint(this.getCodeNorm());
      var owb = this.openWakaBang += char;
      this.text += char;
      if (owb !== "-") {
        this.state = owb === "--" ? S_DTD_COMMENT : S_DTD;
        this.openWakaBang = "";
      }
    }
  }, {
    key: "sDTDComment",
    value: function sDTDComment() {
      if (this.captureToChar(MINUS)) {
        this.text += "-";
        this.state = S_DTD_COMMENT_ENDING;
      }
    }
  }, {
    key: "sDTDCommentEnding",
    value: function sDTDCommentEnding() {
      var c = this.getCodeNorm();
      this.text += String.fromCodePoint(c);
      this.state = c === MINUS ? S_DTD_COMMENT_ENDED : S_DTD_COMMENT;
    }
  }, {
    key: "sDTDCommentEnded",
    value: function sDTDCommentEnded() {
      var c = this.getCodeNorm();
      this.text += String.fromCodePoint(c);
      if (c === GREATER) {
        this.state = S_DTD;
      } else {
        this.fail("malformed comment.");
        // <!-- blah -- bloo --> will be recorded as
        // a comment of " blah -- bloo "
        this.state = S_DTD_COMMENT;
      }
    }
  }, {
    key: "sDTDPI",
    value: function sDTDPI() {
      if (this.captureToChar(QUESTION)) {
        this.text += "?";
        this.state = S_DTD_PI_ENDING;
      }
    }
  }, {
    key: "sDTDPIEnding",
    value: function sDTDPIEnding() {
      var c = this.getCodeNorm();
      this.text += String.fromCodePoint(c);
      if (c === GREATER) {
        this.state = S_DTD;
      }
    }
  }, {
    key: "sText",
    value: function sText() {
      //
      // We did try a version of saxes where the S_TEXT state was split in two
      // states: one for text inside the root element, and one for text
      // outside. This was avoiding having to test this.tags.length to decide
      // what implementation to actually use.
      //
      // Peformance testing on gigabyte-size files did not show any advantage to
      // using the two states solution instead of the current one. Conversely, it
      // made the code a bit more complicated elsewhere. For instance, a comment
      // can appear before the root element so when a comment ended it was
      // necessary to determine whether to return to the S_TEXT state or to the
      // new text-outside-root state.
      //
      if (this.tags.length !== 0) {
        this.handleTextInRoot();
      } else {
        this.handleTextOutsideRoot();
      }
    }
  }, {
    key: "sEntity",
    value: function sEntity() {
      // This is essentially a specialized version of captureToChar(SEMICOLON...)
      var start = this.i;
      var chunk = this.chunk;
      // eslint-disable-next-line no-labels, no-restricted-syntax
      loop:
      // eslint-disable-next-line no-constant-condition
      while (true) {
        switch (this.getCode()) {
          case NL_LIKE:
            this.entity += "".concat(chunk.slice(start, this.prevI), "\n");
            start = this.i;
            break;
          case SEMICOLON:
            {
              var entityReturnState = this.entityReturnState;
              var entity = this.entity + chunk.slice(start, this.prevI);
              this.state = entityReturnState;
              var parsed = void 0;
              if (entity === "") {
                this.fail("empty entity name.");
                parsed = "&;";
              } else {
                parsed = this.parseEntity(entity);
                this.entity = "";
              }
              if (entityReturnState !== S_TEXT || this.textHandler !== undefined) {
                this.text += parsed;
              }
              // eslint-disable-next-line no-labels
              break loop;
            }
          case EOC:
            this.entity += chunk.slice(start);
            // eslint-disable-next-line no-labels
            break loop;
          default:
        }
      }
    }
  }, {
    key: "sOpenWaka",
    value: function sOpenWaka() {
      // Reminder: a state handler is called with at least one character
      // available in the current chunk. So the first call to get code inside of
      // a state handler cannot return ``EOC``. That's why we don't test
      // for it.
      var c = this.getCode();
      // either a /, ?, !, or text is coming next.
      if (isNameStartChar(c)) {
        this.state = S_OPEN_TAG;
        this.unget();
        this.xmlDeclPossible = false;
      } else {
        switch (c) {
          case FORWARD_SLASH:
            this.state = S_CLOSE_TAG;
            this.xmlDeclPossible = false;
            break;
          case BANG:
            this.state = S_OPEN_WAKA_BANG;
            this.openWakaBang = "";
            this.xmlDeclPossible = false;
            break;
          case QUESTION:
            this.state = S_PI_FIRST_CHAR;
            break;
          default:
            this.fail("disallowed character in tag name");
            this.state = S_TEXT;
            this.xmlDeclPossible = false;
        }
      }
    }
  }, {
    key: "sOpenWakaBang",
    value: function sOpenWakaBang() {
      this.openWakaBang += String.fromCodePoint(this.getCodeNorm());
      switch (this.openWakaBang) {
        case "[CDATA[":
          if (!this.sawRoot && !this.reportedTextBeforeRoot) {
            this.fail("text data outside of root node.");
            this.reportedTextBeforeRoot = true;
          }
          if (this.closedRoot && !this.reportedTextAfterRoot) {
            this.fail("text data outside of root node.");
            this.reportedTextAfterRoot = true;
          }
          this.state = S_CDATA;
          this.openWakaBang = "";
          break;
        case "--":
          this.state = S_COMMENT;
          this.openWakaBang = "";
          break;
        case "DOCTYPE":
          this.state = S_DOCTYPE;
          if (this.doctype || this.sawRoot) {
            this.fail("inappropriately located doctype declaration.");
          }
          this.openWakaBang = "";
          break;
        default:
          // 7 happens to be the maximum length of the string that can possibly
          // match one of the cases above.
          if (this.openWakaBang.length >= 7) {
            this.fail("incorrect syntax.");
          }
      }
    }
  }, {
    key: "sComment",
    value: function sComment() {
      if (this.captureToChar(MINUS)) {
        this.state = S_COMMENT_ENDING;
      }
    }
  }, {
    key: "sCommentEnding",
    value: function sCommentEnding() {
      var _a;
      var c = this.getCodeNorm();
      if (c === MINUS) {
        this.state = S_COMMENT_ENDED;
        // eslint-disable-next-line no-unused-expressions
        (_a = this.commentHandler) === null || _a === void 0 ? void 0 : _a.call(this, this.text);
        this.text = "";
      } else {
        this.text += "-".concat(String.fromCodePoint(c));
        this.state = S_COMMENT;
      }
    }
  }, {
    key: "sCommentEnded",
    value: function sCommentEnded() {
      var c = this.getCodeNorm();
      if (c !== GREATER) {
        this.fail("malformed comment.");
        // <!-- blah -- bloo --> will be recorded as
        // a comment of " blah -- bloo "
        this.text += "--".concat(String.fromCodePoint(c));
        this.state = S_COMMENT;
      } else {
        this.state = S_TEXT;
      }
    }
  }, {
    key: "sCData",
    value: function sCData() {
      if (this.captureToChar(CLOSE_BRACKET)) {
        this.state = S_CDATA_ENDING;
      }
    }
  }, {
    key: "sCDataEnding",
    value: function sCDataEnding() {
      var c = this.getCodeNorm();
      if (c === CLOSE_BRACKET) {
        this.state = S_CDATA_ENDING_2;
      } else {
        this.text += "]".concat(String.fromCodePoint(c));
        this.state = S_CDATA;
      }
    }
  }, {
    key: "sCDataEnding2",
    value: function sCDataEnding2() {
      var _a;
      var c = this.getCodeNorm();
      switch (c) {
        case GREATER:
          {
            // eslint-disable-next-line no-unused-expressions
            (_a = this.cdataHandler) === null || _a === void 0 ? void 0 : _a.call(this, this.text);
            this.text = "";
            this.state = S_TEXT;
            break;
          }
        case CLOSE_BRACKET:
          this.text += "]";
          break;
        default:
          this.text += "]]".concat(String.fromCodePoint(c));
          this.state = S_CDATA;
      }
    }
    // We need this separate state to check the first character fo the pi target
    // with this.nameStartCheck which allows less characters than this.nameCheck.
  }, {
    key: "sPIFirstChar",
    value: function sPIFirstChar() {
      var c = this.getCodeNorm();
      // This is first because in the case where the file is well-formed this is
      // the branch taken. We optimize for well-formedness.
      if (this.nameStartCheck(c)) {
        this.piTarget += String.fromCodePoint(c);
        this.state = S_PI_REST;
      } else if (c === QUESTION || isS(c)) {
        this.fail("processing instruction without a target.");
        this.state = c === QUESTION ? S_PI_ENDING : S_PI_BODY;
      } else {
        this.fail("disallowed character in processing instruction name.");
        this.piTarget += String.fromCodePoint(c);
        this.state = S_PI_REST;
      }
    }
  }, {
    key: "sPIRest",
    value: function sPIRest() {
      // Capture characters into a piTarget while ``this.nameCheck`` run on the
      // character read returns true.
      var chunk = this.chunk,
        start = this.i;
      // eslint-disable-next-line no-constant-condition
      while (true) {
        var c = this.getCodeNorm();
        if (c === EOC) {
          this.piTarget += chunk.slice(start);
          return;
        }
        // NL cannot satisfy this.nameCheck so we don't have to test specifically
        // for it.
        if (!this.nameCheck(c)) {
          this.piTarget += chunk.slice(start, this.prevI);
          var isQuestion = c === QUESTION;
          if (isQuestion || isS(c)) {
            if (this.piTarget === "xml") {
              if (!this.xmlDeclPossible) {
                this.fail("an XML declaration must be at the start of the document.");
              }
              this.state = isQuestion ? S_XML_DECL_ENDING : S_XML_DECL_NAME_START;
            } else {
              this.state = isQuestion ? S_PI_ENDING : S_PI_BODY;
            }
          } else {
            this.fail("disallowed character in processing instruction name.");
            this.piTarget += String.fromCodePoint(c);
          }
          break;
        }
      }
    }
  }, {
    key: "sPIBody",
    value: function sPIBody() {
      if (this.text.length === 0) {
        var c = this.getCodeNorm();
        if (c === QUESTION) {
          this.state = S_PI_ENDING;
        } else if (!isS(c)) {
          this.text = String.fromCodePoint(c);
        }
      }
      // The question mark character is not valid inside any of the XML
      // declaration name/value pairs.
      else if (this.captureToChar(QUESTION)) {
        this.state = S_PI_ENDING;
      }
    }
  }, {
    key: "sPIEnding",
    value: function sPIEnding() {
      var _a;
      var c = this.getCodeNorm();
      if (c === GREATER) {
        var piTarget = this.piTarget;
        if (piTarget.toLowerCase() === "xml") {
          this.fail("the XML declaration must appear at the start of the document.");
        }
        // eslint-disable-next-line no-unused-expressions
        (_a = this.piHandler) === null || _a === void 0 ? void 0 : _a.call(this, {
          target: piTarget,
          body: this.text
        });
        this.piTarget = this.text = "";
        this.state = S_TEXT;
      } else if (c === QUESTION) {
        // We ran into ?? as part of a processing instruction. We initially took
        // the first ? as a sign that the PI was ending, but it is not. So we have
        // to add it to the body but we take the new ? as a sign that the PI is
        // ending.
        this.text += "?";
      } else {
        this.text += "?".concat(String.fromCodePoint(c));
        this.state = S_PI_BODY;
      }
      this.xmlDeclPossible = false;
    }
  }, {
    key: "sXMLDeclNameStart",
    value: function sXMLDeclNameStart() {
      var c = this.skipSpaces();
      // The question mark character is not valid inside any of the XML
      // declaration name/value pairs.
      if (c === QUESTION) {
        // It is valid to go to S_XML_DECL_ENDING from this state.
        this.state = S_XML_DECL_ENDING;
        return;
      }
      if (c !== EOC) {
        this.state = S_XML_DECL_NAME;
        this.name = String.fromCodePoint(c);
      }
    }
  }, {
    key: "sXMLDeclName",
    value: function sXMLDeclName() {
      var c = this.captureTo(XML_DECL_NAME_TERMINATOR);
      // The question mark character is not valid inside any of the XML
      // declaration name/value pairs.
      if (c === QUESTION) {
        this.state = S_XML_DECL_ENDING;
        this.name += this.text;
        this.text = "";
        this.fail("XML declaration is incomplete.");
        return;
      }
      if (!(isS(c) || c === EQUAL)) {
        return;
      }
      this.name += this.text;
      this.text = "";
      if (!this.xmlDeclExpects.includes(this.name)) {
        switch (this.name.length) {
          case 0:
            this.fail("did not expect any more name/value pairs.");
            break;
          case 1:
            this.fail("expected the name ".concat(this.xmlDeclExpects[0], "."));
            break;
          default:
            this.fail("expected one of ".concat(this.xmlDeclExpects.join(", ")));
        }
      }
      this.state = c === EQUAL ? S_XML_DECL_VALUE_START : S_XML_DECL_EQ;
    }
  }, {
    key: "sXMLDeclEq",
    value: function sXMLDeclEq() {
      var c = this.getCodeNorm();
      // The question mark character is not valid inside any of the XML
      // declaration name/value pairs.
      if (c === QUESTION) {
        this.state = S_XML_DECL_ENDING;
        this.fail("XML declaration is incomplete.");
        return;
      }
      if (isS(c)) {
        return;
      }
      if (c !== EQUAL) {
        this.fail("value required.");
      }
      this.state = S_XML_DECL_VALUE_START;
    }
  }, {
    key: "sXMLDeclValueStart",
    value: function sXMLDeclValueStart() {
      var c = this.getCodeNorm();
      // The question mark character is not valid inside any of the XML
      // declaration name/value pairs.
      if (c === QUESTION) {
        this.state = S_XML_DECL_ENDING;
        this.fail("XML declaration is incomplete.");
        return;
      }
      if (isS(c)) {
        return;
      }
      if (!isQuote(c)) {
        this.fail("value must be quoted.");
        this.q = SPACE;
      } else {
        this.q = c;
      }
      this.state = S_XML_DECL_VALUE;
    }
  }, {
    key: "sXMLDeclValue",
    value: function sXMLDeclValue() {
      var c = this.captureTo([this.q, QUESTION]);
      // The question mark character is not valid inside any of the XML
      // declaration name/value pairs.
      if (c === QUESTION) {
        this.state = S_XML_DECL_ENDING;
        this.text = "";
        this.fail("XML declaration is incomplete.");
        return;
      }
      if (c === EOC) {
        return;
      }
      var value = this.text;
      this.text = "";
      switch (this.name) {
        case "version":
          {
            this.xmlDeclExpects = ["encoding", "standalone"];
            var version = value;
            this.xmlDecl.version = version;
            // This is the test specified by XML 1.0 but it is fine for XML 1.1.
            if (!/^1\.[0-9]+$/.test(version)) {
              this.fail("version number must match /^1\\.[0-9]+$/.");
            }
            // When forceXMLVersion is set, the XML declaration is ignored.
            else if (!this.opt.forceXMLVersion) {
              this.setXMLVersion(version);
            }
            break;
          }
        case "encoding":
          if (!/^[A-Za-z][A-Za-z0-9._-]*$/.test(value)) {
            this.fail("encoding value must match \
/^[A-Za-z0-9][A-Za-z0-9._-]*$/.");
          }
          this.xmlDeclExpects = ["standalone"];
          this.xmlDecl.encoding = value;
          break;
        case "standalone":
          if (value !== "yes" && value !== "no") {
            this.fail("standalone value must match \"yes\" or \"no\".");
          }
          this.xmlDeclExpects = [];
          this.xmlDecl.standalone = value;
          break;
        default:
        // We don't need to raise an error here since we've already raised one
        // when checking what name was expected.
      }
      this.name = "";
      this.state = S_XML_DECL_SEPARATOR;
    }
  }, {
    key: "sXMLDeclSeparator",
    value: function sXMLDeclSeparator() {
      var c = this.getCodeNorm();
      // The question mark character is not valid inside any of the XML
      // declaration name/value pairs.
      if (c === QUESTION) {
        // It is valid to go to S_XML_DECL_ENDING from this state.
        this.state = S_XML_DECL_ENDING;
        return;
      }
      if (!isS(c)) {
        this.fail("whitespace required.");
        this.unget();
      }
      this.state = S_XML_DECL_NAME_START;
    }
  }, {
    key: "sXMLDeclEnding",
    value: function sXMLDeclEnding() {
      var _a;
      var c = this.getCodeNorm();
      if (c === GREATER) {
        if (this.piTarget !== "xml") {
          this.fail("processing instructions are not allowed before root.");
        } else if (this.name !== "version" && this.xmlDeclExpects.includes("version")) {
          this.fail("XML declaration must contain a version.");
        }
        // eslint-disable-next-line no-unused-expressions
        (_a = this.xmldeclHandler) === null || _a === void 0 ? void 0 : _a.call(this, this.xmlDecl);
        this.name = "";
        this.piTarget = this.text = "";
        this.state = S_TEXT;
      } else {
        // We got here because the previous character was a ?, but the question
        // mark character is not valid inside any of the XML declaration
        // name/value pairs.
        this.fail("The character ? is disallowed anywhere in XML declarations.");
      }
      this.xmlDeclPossible = false;
    }
  }, {
    key: "sOpenTag",
    value: function sOpenTag() {
      var _a;
      var c = this.captureNameChars();
      if (c === EOC) {
        return;
      }
      var tag = this.tag = {
        name: this.name,
        attributes: Object.create(null)
      };
      this.name = "";
      if (this.xmlnsOpt) {
        this.topNS = tag.ns = Object.create(null);
      }
      // eslint-disable-next-line no-unused-expressions
      (_a = this.openTagStartHandler) === null || _a === void 0 ? void 0 : _a.call(this, tag);
      this.sawRoot = true;
      if (!this.fragmentOpt && this.closedRoot) {
        this.fail("documents may contain only one root.");
      }
      switch (c) {
        case GREATER:
          this.openTag();
          break;
        case FORWARD_SLASH:
          this.state = S_OPEN_TAG_SLASH;
          break;
        default:
          if (!isS(c)) {
            this.fail("disallowed character in tag name.");
          }
          this.state = S_ATTRIB;
      }
    }
  }, {
    key: "sOpenTagSlash",
    value: function sOpenTagSlash() {
      if (this.getCode() === GREATER) {
        this.openSelfClosingTag();
      } else {
        this.fail("forward-slash in opening tag not followed by >.");
        this.state = S_ATTRIB;
      }
    }
  }, {
    key: "sAttrib",
    value: function sAttrib() {
      var c = this.skipSpaces();
      if (c === EOC) {
        return;
      }
      if (isNameStartChar(c)) {
        this.unget();
        this.state = S_ATTRIB_NAME;
      } else if (c === GREATER) {
        this.openTag();
      } else if (c === FORWARD_SLASH) {
        this.state = S_OPEN_TAG_SLASH;
      } else {
        this.fail("disallowed character in attribute name.");
      }
    }
  }, {
    key: "sAttribName",
    value: function sAttribName() {
      var c = this.captureNameChars();
      if (c === EQUAL) {
        this.state = S_ATTRIB_VALUE;
      } else if (isS(c)) {
        this.state = S_ATTRIB_NAME_SAW_WHITE;
      } else if (c === GREATER) {
        this.fail("attribute without value.");
        this.pushAttrib(this.name, this.name);
        this.name = this.text = "";
        this.openTag();
      } else if (c !== EOC) {
        this.fail("disallowed character in attribute name.");
      }
    }
  }, {
    key: "sAttribNameSawWhite",
    value: function sAttribNameSawWhite() {
      var c = this.skipSpaces();
      switch (c) {
        case EOC:
          return;
        case EQUAL:
          this.state = S_ATTRIB_VALUE;
          break;
        default:
          this.fail("attribute without value.");
          // Should we do this???
          // this.tag.attributes[this.name] = "";
          this.text = "";
          this.name = "";
          if (c === GREATER) {
            this.openTag();
          } else if (isNameStartChar(c)) {
            this.unget();
            this.state = S_ATTRIB_NAME;
          } else {
            this.fail("disallowed character in attribute name.");
            this.state = S_ATTRIB;
          }
      }
    }
  }, {
    key: "sAttribValue",
    value: function sAttribValue() {
      var c = this.getCodeNorm();
      if (isQuote(c)) {
        this.q = c;
        this.state = S_ATTRIB_VALUE_QUOTED;
      } else if (!isS(c)) {
        this.fail("unquoted attribute value.");
        this.state = S_ATTRIB_VALUE_UNQUOTED;
        this.unget();
      }
    }
  }, {
    key: "sAttribValueQuoted",
    value: function sAttribValueQuoted() {
      // We deliberately do not use captureTo here. The specialized code we use
      // here is faster than using captureTo.
      var q = this.q,
        chunk = this.chunk;
      var start = this.i;
      // eslint-disable-next-line no-constant-condition
      while (true) {
        switch (this.getCode()) {
          case q:
            this.pushAttrib(this.name, this.text + chunk.slice(start, this.prevI));
            this.name = this.text = "";
            this.q = null;
            this.state = S_ATTRIB_VALUE_CLOSED;
            return;
          case AMP:
            this.text += chunk.slice(start, this.prevI);
            this.state = S_ENTITY;
            this.entityReturnState = S_ATTRIB_VALUE_QUOTED;
            return;
          case NL:
          case NL_LIKE:
          case TAB:
            this.text += "".concat(chunk.slice(start, this.prevI), " ");
            start = this.i;
            break;
          case LESS:
            this.text += chunk.slice(start, this.prevI);
            this.fail("disallowed character.");
            return;
          case EOC:
            this.text += chunk.slice(start);
            return;
          default:
        }
      }
    }
  }, {
    key: "sAttribValueClosed",
    value: function sAttribValueClosed() {
      var c = this.getCodeNorm();
      if (isS(c)) {
        this.state = S_ATTRIB;
      } else if (c === GREATER) {
        this.openTag();
      } else if (c === FORWARD_SLASH) {
        this.state = S_OPEN_TAG_SLASH;
      } else if (isNameStartChar(c)) {
        this.fail("no whitespace between attributes.");
        this.unget();
        this.state = S_ATTRIB_NAME;
      } else {
        this.fail("disallowed character in attribute name.");
      }
    }
  }, {
    key: "sAttribValueUnquoted",
    value: function sAttribValueUnquoted() {
      // We don't do anything regarding EOL or space handling for unquoted
      // attributes. We already have failed by the time we get here, and the
      // contract that saxes upholds states that upon failure, it is not safe to
      // rely on the data passed to event handlers (other than
      // ``onerror``). Passing "bad" data is not a problem.
      var c = this.captureTo(ATTRIB_VALUE_UNQUOTED_TERMINATOR);
      switch (c) {
        case AMP:
          this.state = S_ENTITY;
          this.entityReturnState = S_ATTRIB_VALUE_UNQUOTED;
          break;
        case LESS:
          this.fail("disallowed character.");
          break;
        case EOC:
          break;
        default:
          if (this.text.includes("]]>")) {
            this.fail("the string \"]]>\" is disallowed in char data.");
          }
          this.pushAttrib(this.name, this.text);
          this.name = this.text = "";
          if (c === GREATER) {
            this.openTag();
          } else {
            this.state = S_ATTRIB;
          }
      }
    }
  }, {
    key: "sCloseTag",
    value: function sCloseTag() {
      var c = this.captureNameChars();
      if (c === GREATER) {
        this.closeTag();
      } else if (isS(c)) {
        this.state = S_CLOSE_TAG_SAW_WHITE;
      } else if (c !== EOC) {
        this.fail("disallowed character in closing tag.");
      }
    }
  }, {
    key: "sCloseTagSawWhite",
    value: function sCloseTagSawWhite() {
      switch (this.skipSpaces()) {
        case GREATER:
          this.closeTag();
          break;
        case EOC:
          break;
        default:
          this.fail("disallowed character in closing tag.");
      }
    }
    // END OF STATE ENGINE METHODS
  }, {
    key: "handleTextInRoot",
    value: function handleTextInRoot() {
      // This is essentially a specialized version of captureTo which is optimized
      // for performing the ]]> check. A previous version of this code, checked
      // ``this.text`` for the presence of ]]>. It simplified the code but was
      // very costly when character data contained a lot of entities to be parsed.
      //
      // Since we are using a specialized loop, we also keep track of the presence
      // of ]]> in text data. The sequence ]]> is forbidden to appear as-is.
      //
      var start = this.i,
        forbiddenState = this.forbiddenState;
      var chunk = this.chunk,
        handler = this.textHandler;
      // eslint-disable-next-line no-labels, no-restricted-syntax
      scanLoop:
      // eslint-disable-next-line no-constant-condition
      while (true) {
        switch (this.getCode()) {
          case LESS:
            {
              this.state = S_OPEN_WAKA;
              if (handler !== undefined) {
                var text = this.text;
                var slice = chunk.slice(start, this.prevI);
                if (text.length !== 0) {
                  handler(text + slice);
                  this.text = "";
                } else if (slice.length !== 0) {
                  handler(slice);
                }
              }
              forbiddenState = FORBIDDEN_START;
              // eslint-disable-next-line no-labels
              break scanLoop;
            }
          case AMP:
            this.state = S_ENTITY;
            this.entityReturnState = S_TEXT;
            if (handler !== undefined) {
              this.text += chunk.slice(start, this.prevI);
            }
            forbiddenState = FORBIDDEN_START;
            // eslint-disable-next-line no-labels
            break scanLoop;
          case CLOSE_BRACKET:
            switch (forbiddenState) {
              case FORBIDDEN_START:
                forbiddenState = FORBIDDEN_BRACKET;
                break;
              case FORBIDDEN_BRACKET:
                forbiddenState = FORBIDDEN_BRACKET_BRACKET;
                break;
              case FORBIDDEN_BRACKET_BRACKET:
                break;
              default:
                throw new Error("impossible state");
            }
            break;
          case GREATER:
            if (forbiddenState === FORBIDDEN_BRACKET_BRACKET) {
              this.fail("the string \"]]>\" is disallowed in char data.");
            }
            forbiddenState = FORBIDDEN_START;
            break;
          case NL_LIKE:
            if (handler !== undefined) {
              this.text += "".concat(chunk.slice(start, this.prevI), "\n");
            }
            start = this.i;
            forbiddenState = FORBIDDEN_START;
            break;
          case EOC:
            if (handler !== undefined) {
              this.text += chunk.slice(start);
            }
            // eslint-disable-next-line no-labels
            break scanLoop;
          default:
            forbiddenState = FORBIDDEN_START;
        }
      }
      this.forbiddenState = forbiddenState;
    }
  }, {
    key: "handleTextOutsideRoot",
    value: function handleTextOutsideRoot() {
      // This is essentially a specialized version of captureTo which is optimized
      // for a specialized task. We keep track of the presence of non-space
      // characters in the text since these are errors when appearing outside the
      // document root element.
      var start = this.i;
      var chunk = this.chunk,
        handler = this.textHandler;
      var nonSpace = false;
      // eslint-disable-next-line no-labels, no-restricted-syntax
      outRootLoop:
      // eslint-disable-next-line no-constant-condition
      while (true) {
        var code = this.getCode();
        switch (code) {
          case LESS:
            {
              this.state = S_OPEN_WAKA;
              if (handler !== undefined) {
                var text = this.text;
                var slice = chunk.slice(start, this.prevI);
                if (text.length !== 0) {
                  handler(text + slice);
                  this.text = "";
                } else if (slice.length !== 0) {
                  handler(slice);
                }
              }
              // eslint-disable-next-line no-labels
              break outRootLoop;
            }
          case AMP:
            this.state = S_ENTITY;
            this.entityReturnState = S_TEXT;
            if (handler !== undefined) {
              this.text += chunk.slice(start, this.prevI);
            }
            nonSpace = true;
            // eslint-disable-next-line no-labels
            break outRootLoop;
          case NL_LIKE:
            if (handler !== undefined) {
              this.text += "".concat(chunk.slice(start, this.prevI), "\n");
            }
            start = this.i;
            break;
          case EOC:
            if (handler !== undefined) {
              this.text += chunk.slice(start);
            }
            // eslint-disable-next-line no-labels
            break outRootLoop;
          default:
            if (!isS(code)) {
              nonSpace = true;
            }
        }
      }
      if (!nonSpace) {
        return;
      }
      // We use the reportedTextBeforeRoot and reportedTextAfterRoot flags
      // to avoid reporting errors for every single character that is out of
      // place.
      if (!this.sawRoot && !this.reportedTextBeforeRoot) {
        this.fail("text data outside of root node.");
        this.reportedTextBeforeRoot = true;
      }
      if (this.closedRoot && !this.reportedTextAfterRoot) {
        this.fail("text data outside of root node.");
        this.reportedTextAfterRoot = true;
      }
    }
  }, {
    key: "pushAttribNS",
    value: function pushAttribNS(name, value) {
      var _a;
      var _this$qname = this.qname(name),
        prefix = _this$qname.prefix,
        local = _this$qname.local;
      var attr = {
        name: name,
        prefix: prefix,
        local: local,
        value: value
      };
      this.attribList.push(attr);
      // eslint-disable-next-line no-unused-expressions
      (_a = this.attributeHandler) === null || _a === void 0 ? void 0 : _a.call(this, attr);
      if (prefix === "xmlns") {
        var trimmed = value.trim();
        if (this.currentXMLVersion === "1.0" && trimmed === "") {
          this.fail("invalid attempt to undefine prefix in XML 1.0");
        }
        this.topNS[local] = trimmed;
        nsPairCheck(this, local, trimmed);
      } else if (name === "xmlns") {
        var _trimmed = value.trim();
        this.topNS[""] = _trimmed;
        nsPairCheck(this, "", _trimmed);
      }
    }
  }, {
    key: "pushAttribPlain",
    value: function pushAttribPlain(name, value) {
      var _a;
      var attr = {
        name: name,
        value: value
      };
      this.attribList.push(attr);
      // eslint-disable-next-line no-unused-expressions
      (_a = this.attributeHandler) === null || _a === void 0 ? void 0 : _a.call(this, attr);
    }
    /**
     * End parsing. This performs final well-formedness checks and resets the
     * parser to a clean state.
     *
     * @returns this
     */
  }, {
    key: "end",
    value: function end() {
      var _a, _b;
      if (!this.sawRoot) {
        this.fail("document must contain a root element.");
      }
      var tags = this.tags;
      while (tags.length > 0) {
        var tag = tags.pop();
        this.fail("unclosed tag: ".concat(tag.name));
      }
      if (this.state !== S_BEGIN && this.state !== S_TEXT) {
        this.fail("unexpected end.");
      }
      var text = this.text;
      if (text.length !== 0) {
        // eslint-disable-next-line no-unused-expressions
        (_a = this.textHandler) === null || _a === void 0 ? void 0 : _a.call(this, text);
        this.text = "";
      }
      this._closed = true;
      // eslint-disable-next-line no-unused-expressions
      (_b = this.endHandler) === null || _b === void 0 ? void 0 : _b.call(this);
      this._init();
      return this;
    }
    /**
     * Resolve a namespace prefix.
     *
     * @param prefix The prefix to resolve.
     *
     * @returns The namespace URI or ``undefined`` if the prefix is not defined.
     */
  }, {
    key: "resolve",
    value: function resolve(prefix) {
      var _a, _b;
      var uri = this.topNS[prefix];
      if (uri !== undefined) {
        return uri;
      }
      var tags = this.tags;
      for (var index = tags.length - 1; index >= 0; index--) {
        uri = tags[index].ns[prefix];
        if (uri !== undefined) {
          return uri;
        }
      }
      uri = this.ns[prefix];
      if (uri !== undefined) {
        return uri;
      }
      return (_b = (_a = this.opt).resolvePrefix) === null || _b === void 0 ? void 0 : _b.call(_a, prefix);
    }
    /**
     * Parse a qname into its prefix and local name parts.
     *
     * @param name The name to parse
     *
     * @returns
     */
  }, {
    key: "qname",
    value: function qname(name) {
      // This is faster than using name.split(":").
      var colon = name.indexOf(":");
      if (colon === -1) {
        return {
          prefix: "",
          local: name
        };
      }
      var local = name.slice(colon + 1);
      var prefix = name.slice(0, colon);
      if (prefix === "" || local === "" || local.includes(":")) {
        this.fail("malformed name: ".concat(name, "."));
      }
      return {
        prefix: prefix,
        local: local
      };
    }
  }, {
    key: "processAttribsNS",
    value: function processAttribsNS() {
      var _a;
      var attribList = this.attribList;
      var tag = this.tag;
      {
        // add namespace info to tag
        var _this$qname2 = this.qname(tag.name),
          prefix = _this$qname2.prefix,
          local = _this$qname2.local;
        tag.prefix = prefix;
        tag.local = local;
        var uri = tag.uri = (_a = this.resolve(prefix)) !== null && _a !== void 0 ? _a : "";
        if (prefix !== "") {
          if (prefix === "xmlns") {
            this.fail("tags may not have \"xmlns\" as prefix.");
          }
          if (uri === "") {
            this.fail("unbound namespace prefix: ".concat(JSON.stringify(prefix), "."));
            tag.uri = prefix;
          }
        }
      }
      if (attribList.length === 0) {
        return;
      }
      var attributes = tag.attributes;
      var seen = new Set();
      // Note: do not apply default ns to attributes:
      //   http://www.w3.org/TR/REC-xml-names/#defaulting
      var _iterator = _createForOfIteratorHelper(attribList),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var attr = _step.value;
          var name = attr.name,
            _prefix = attr.prefix,
            _local = attr.local;
          var _uri = void 0;
          var eqname = void 0;
          if (_prefix === "") {
            _uri = name === "xmlns" ? XMLNS_NAMESPACE : "";
            eqname = name;
          } else {
            _uri = this.resolve(_prefix);
            // if there's any attributes with an undefined namespace,
            // then fail on them now.
            if (_uri === undefined) {
              this.fail("unbound namespace prefix: ".concat(JSON.stringify(_prefix), "."));
              _uri = _prefix;
            }
            eqname = "{".concat(_uri, "}").concat(_local);
          }
          if (seen.has(eqname)) {
            this.fail("duplicate attribute: ".concat(eqname, "."));
          }
          seen.add(eqname);
          attr.uri = _uri;
          attributes[name] = attr;
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
      this.attribList = [];
    }
  }, {
    key: "processAttribsPlain",
    value: function processAttribsPlain() {
      var attribList = this.attribList;
      // eslint-disable-next-line prefer-destructuring
      var attributes = this.tag.attributes;
      var _iterator2 = _createForOfIteratorHelper(attribList),
        _step2;
      try {
        for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
          var _step2$value = _step2.value,
            name = _step2$value.name,
            value = _step2$value.value;
          if (attributes[name] !== undefined) {
            this.fail("duplicate attribute: ".concat(name, "."));
          }
          attributes[name] = value;
        }
      } catch (err) {
        _iterator2.e(err);
      } finally {
        _iterator2.f();
      }
      this.attribList = [];
    }
    /**
     * Handle a complete open tag. This parser code calls this once it has seen
     * the whole tag. This method checks for well-formeness and then emits
     * ``onopentag``.
     */
  }, {
    key: "openTag",
    value: function openTag() {
      var _a;
      this.processAttribs();
      var tags = this.tags;
      var tag = this.tag;
      tag.isSelfClosing = false;
      // There cannot be any pending text here due to the onopentagstart that was
      // necessarily emitted before we get here. So we do not check text.
      // eslint-disable-next-line no-unused-expressions
      (_a = this.openTagHandler) === null || _a === void 0 ? void 0 : _a.call(this, tag);
      tags.push(tag);
      this.state = S_TEXT;
      this.name = "";
    }
    /**
     * Handle a complete self-closing tag. This parser code calls this once it has
     * seen the whole tag. This method checks for well-formeness and then emits
     * ``onopentag`` and ``onclosetag``.
     */
  }, {
    key: "openSelfClosingTag",
    value: function openSelfClosingTag() {
      var _a, _b, _c;
      this.processAttribs();
      var tags = this.tags;
      var tag = this.tag;
      tag.isSelfClosing = true;
      // There cannot be any pending text here due to the onopentagstart that was
      // necessarily emitted before we get here. So we do not check text.
      // eslint-disable-next-line no-unused-expressions
      (_a = this.openTagHandler) === null || _a === void 0 ? void 0 : _a.call(this, tag);
      // eslint-disable-next-line no-unused-expressions
      (_b = this.closeTagHandler) === null || _b === void 0 ? void 0 : _b.call(this, tag);
      var top = this.tag = (_c = tags[tags.length - 1]) !== null && _c !== void 0 ? _c : null;
      if (top === null) {
        this.closedRoot = true;
      }
      this.state = S_TEXT;
      this.name = "";
    }
    /**
     * Handle a complete close tag. This parser code calls this once it has seen
     * the whole tag. This method checks for well-formeness and then emits
     * ``onclosetag``.
     */
  }, {
    key: "closeTag",
    value: function closeTag() {
      var tags = this.tags,
        name = this.name;
      // Our state after this will be S_TEXT, no matter what, and we can clear
      // tagName now.
      this.state = S_TEXT;
      this.name = "";
      if (name === "") {
        this.fail("weird empty close tag.");
        this.text += "</>";
        return;
      }
      var handler = this.closeTagHandler;
      var l = tags.length;
      while (l-- > 0) {
        var tag = this.tag = tags.pop();
        this.topNS = tag.ns;
        // eslint-disable-next-line no-unused-expressions
        handler === null || handler === void 0 ? void 0 : handler(tag);
        if (tag.name === name) {
          break;
        }
        this.fail("unexpected close tag.");
      }
      if (l === 0) {
        this.closedRoot = true;
      } else if (l < 0) {
        this.fail("unmatched closing tag: ".concat(name, "."));
        this.text += "</".concat(name, ">");
      }
    }
    /**
     * Resolves an entity. Makes any necessary well-formedness checks.
     *
     * @param entity The entity to resolve.
     *
     * @returns The parsed entity.
     */
  }, {
    key: "parseEntity",
    value: function parseEntity(entity) {
      // startsWith would be significantly slower for this test.
      // eslint-disable-next-line @typescript-eslint/prefer-string-starts-ends-with
      if (entity[0] !== "#") {
        var defined = this.ENTITIES[entity];
        if (defined !== undefined) {
          return defined;
        }
        this.fail(this.isName(entity) ? "undefined entity." : "disallowed character in entity name.");
        return "&".concat(entity, ";");
      }
      var num = NaN;
      if (entity[1] === "x" && /^#x[0-9a-f]+$/i.test(entity)) {
        num = parseInt(entity.slice(2), 16);
      } else if (/^#[0-9]+$/.test(entity)) {
        num = parseInt(entity.slice(1), 10);
      }
      // The character reference is required to match the CHAR production.
      if (!this.isChar(num)) {
        this.fail("malformed character entity.");
        return "&".concat(entity, ";");
      }
      return String.fromCodePoint(num);
    }
  }]);
}();
exports.SaxesParser = SaxesParser;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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